/* import __COLOCATED_TEMPLATE__ from './buyer-actions.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { APPLICATION } from 'sh-www/models/application';
import { htmlEntitiesDecode } from 'sh-www/utils/misc';
import { dropTask } from 'ember-concurrency';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-c-seller-applications-buyer-actions';

const ACTION_CLASS_NAME = `${CLASS_NAME}__action`;
const ACTION_HIRED_CLASS_NAME = `${ACTION_CLASS_NAME}--hired`;
const ACTION_PENDING_CLASS_NAME = `${ACTION_CLASS_NAME}--pending`;

class SellerApplicationsBuyerActions extends Component {
  @service('state-managers/application') applicationStateManager;
  @service('error-tracker') errorTracker;

  @tracked isFavorite = this.args.application.isFavorite;

  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get offerActionClassNames() {
    return clsx(
      ACTION_CLASS_NAME,
      this.isApplicationInHiredState && ACTION_HIRED_CLASS_NAME,
      this.isApplicationOfferPending && ACTION_PENDING_CLASS_NAME,
    );
  }

  get offerActionText() {
    if (this.isApplicationInHiredState) {
      return 'Hired';
    } else if (this.isApplicationOfferPending) {
      return 'Offer Pending';
    }

    return 'Make Offer';
  }

  get isApplicationDeclined() {
    const { status } = this.args.application;
    return APPLICATION.SIMPLE_STATUS_MAPPING[APPLICATION.SIMPLE_STATUS.DECLINED].includes(status);
  }

  get isApplicationInHiredState() {
    const { status } = this.args.application;
    return APPLICATION.SIMPLE_STATUS_MAPPING[APPLICATION.SIMPLE_STATUS.HIRED].includes(status);
  }

  get isApplicationOfferPending() {
    const { status } = this.args.application;
    return APPLICATION.SIMPLE_STATUS_MAPPING[APPLICATION.SIMPLE_STATUS.IN_PROGRESS].includes(status);
  }

  @action
  hireCreator(application, e) {
    e.preventDefault();
    e.stopPropagation();

    this.args.hireCreator(application);
  }

  @action
  toggleDeclined(application, e) {
    e.preventDefault();
    e.stopPropagation();

    if (this.isApplicationDeclined) {
      this.args.undeclineApplication(application);
    } else {
      this.args.declineApplication(application);
    }
  }

  @dropTask
  *toggleFavoriteTask(application, e) {
    e.preventDefault();
    e.stopPropagation();

    const { isFavorite } = this;

    // show as updated immediately
    this.isFavorite = !isFavorite;

    try {
      if (isFavorite) {
        yield this.args.removeFavorite(application);
      } else {
        yield this.args.addFavorite(application);
      }
    } catch(e) {
      // revert state on error
      this.isFavorite = isFavorite;

      this.errorTracker.error('Failed set toggle a postings saved status');

      const favoriteWord = isFavorite
        ? 'un-favorite'
        : 'favorite';

      this.applicationStateManager.addToast(`Failed to ${favoriteWord} "${htmlEntitiesDecode(application.title)}". Try again later.`);
    }
  }
}

export default SellerApplicationsBuyerActions;
